<template>
  <div class="content conta">
    <h1><span><i class="fas fa-book"></i> Conteúdo</span></h1>
    <b-tabs pills nav-class="mb-5 mt-5" lazy>
      <b-tab title="Cursos" @click="changeRouter('cursos')" :active="isActive('cursos')">
        <lista-cursos :perfil="perfil" />
      </b-tab>
      <b-tab title="Questões" @click="changeRouter('questoes')" :active="isActive('questoes')">
        <lista-questoes :perfil="perfil" />
      </b-tab>
      <b-tab title="Simulados" @click="changeRouter('simulados')" :active="isActive('simulados')">
        <lista-simulados :perfil="perfil" />
      </b-tab>
      <b-tab title="Vídeos" @click="changeRouter('videos')" :active="isActive('videos')">
        <lista-videos :perfil="perfil" />
      </b-tab>
      <b-tab title="Imagens" @click="changeRouter('imagens')" :active="isActive('imagens')">
        <lista-imagens :perfil="perfil" />
      </b-tab>
      <b-tab title="PDFs" @click="changeRouter('pdfs')" :active="isActive('pdfs')">
        <lista-pdfs :perfil="perfil" />
      </b-tab>
      <b-tab title="Textos" @click="changeRouter('textos')" :active="isActive('textos')">
        <ListaTextos :perfil="perfil"></ListaTextos>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { TipoPerfilUtil } from '@/core/types/tipo-perfil'
import LoginUtils from '@/core/util/login-utils'

import ListaTextos from '@/modules/Conteudo/components/ListaTextos'
import ListaCursos from '@/modules/Conteudo/components/ListaCursos'
import ListaQuestoes from '@/modules/Conteudo/components/ListaQuestoes'
import ListaSimulados from '@/modules/Conteudo/components/ListaSimulados'
import ListaVideos from '@/modules/Conteudo/components/ListaVideos'
import ListaImagens from '@/modules/Conteudo/components/ListaImagens'
import ListaPdfs from '@/modules/Conteudo/components/ListaPdfs'

export default {
  name: 'ConteudoView',
  components: { ListaQuestoes, ListaSimulados, ListaCursos, ListaVideos, ListaTextos, ListaImagens, ListaPdfs },
  methods: {
    isActive: function (tab) {
      return this.$route.params.activeTab === tab
    },

    changeRouter: function (tab) {
      this.$router.push(`/conteudo/${tab}`)
    }
  },
  computed: {
    perfil: function () {
      return {
        isMaster: TipoPerfilUtil.isMaster(LoginUtils.getUsuario().perfil_id),

        isAdminJaleko: TipoPerfilUtil.isAdminJaleko(LoginUtils.getUsuario().perfil_id),

        isAdmin: TipoPerfilUtil.isAdmin(LoginUtils.getUsuario().perfil_id),

        isAdminRestrito: TipoPerfilUtil.isAdminRestrito(LoginUtils.getUsuario().perfil_id),

        isAnalista: TipoPerfilUtil.isAnalista(LoginUtils.getUsuario().perfil_id),

        isProfessor: TipoPerfilUtil.isProfessor(LoginUtils.getUsuario().perfil_id),

        isEditor: TipoPerfilUtil.isEditor(LoginUtils.getUsuario().perfil_id),

        isAluno: TipoPerfilUtil.isAluno(LoginUtils.getUsuario().perfil_id)
      }
    }
  }
}
</script>

<style scoped>

</style>
